import {toast} from 'react-toastify'
import {refreshTokens} from 'utils/auth/refreshTokens'

interface FetchTokenOptions {
 silent?: boolean
}

const fetchTokenFromRefreshToken = async (
 refreshToken: string,
 options: FetchTokenOptions = {}
) => {
 const result = await refreshTokens(refreshToken)
 if (result) {
  return {
   auth: {
    accessToken: result.accessToken,
    refreshToken: result.refreshToken,
    accessExpiresIn: result.accessExpiresIn,
    refreshExpiresIn: result.refreshExpiresIn,
   },
  }
 }

 if (!options.silent) {
  toast.error('Session expired. Please log in again.')
 }
 return null
}

export default fetchTokenFromRefreshToken
